module.exports = __webpack_public_path__ + "media/images/emblems/Ropraz-95dea6d2a2ee438a2713a7651d289982.png";